// User settings that are not per photo (§9 metadata, §11.15 watermark/logo), stored in IndexedDB.
import { createStore, get, set, type UseStore } from 'idb-keyval';
import { DEFAULT_WATERMARK, type WatermarkSettings } from './watermark';
import type { MetadataSettings } from '../io/encode/xmp';

let db: UseStore | null = null;
const store = () => (db ??= createStore('epb-settings', 'settings'));

async function read<T>(key: string, fallback: T): Promise<T> {
  try {
    return (await get<T>(key, store())) ?? fallback;
  } catch {
    return fallback;
  }
}
async function write<T>(key: string, v: T) {
  try {
    await set(key, v, store());
  } catch {
    /* not persisted */
  }
}

export const loadWatermark = () => read<WatermarkSettings>('watermark', DEFAULT_WATERMARK);
export const saveWatermark = (w: WatermarkSettings) => write('watermark', { ...w, logo: undefined });
export const loadLogo = () => read<Uint8Array | null>('logo', null);
export const saveLogo = (b: Uint8Array) => write('logo', b);
export const loadMetadata = () => read<MetadataSettings>('metadata', {});
export const saveMetadata = (m: MetadataSettings) => write('metadata', m);
